// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"c9065e31","129":"c2db14af","191":"ec876cde","288":"42683bd4","352":"cec09095","359":"13ae6b9f","716":"62858621","748":"3d759875","756":"a63ebebd"}[chunkId] + ".chunk.js";
};